module.exports = __webpack_public_path__ + "static/media/01.1086f8eb.jpg";